import React from 'react';
import styled, { css } from 'styled-components';

const BodyInner: React.FCC = ({ children }) => (
  <Container>{children}</Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    flex-grow: 1;
    align-self: start;
    border-bottom-left-radius: ${theme.getTokens().border.radius.m};
    border-bottom-right-radius: ${theme.getTokens().border.radius.m};
  `,
);

export default BodyInner;
